import {
  AccessControl,
  PermissionRequired,
  //@ts-ignore
} from "@careinfo/permission-required";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CityList from "../pages/City/CityList";
import CreateCity from "../pages/City/CreateCity";
import EditCity from "../pages/City/EditCity";
import CountryList from "../pages/Country/CountryList";
import CreateCountry from "../pages/Country/CreateCountry";
import EditCountry from "../pages/Country/EditCountry";
import CreateDistrict from "../pages/District/CreateDistrict";
import DistrictList from "../pages/District/DistrictList";
import EditDistrict from "../pages/District/EditDistrict";
import CreateState from "../pages/State/CreateState";
import EditState from "../pages/State/EditState";
import StateList from "../pages/State/StateList";
import GroupList from "../pages/Group/GroupList";
import CreateGroup from "../pages/Group/CreateGroup";
import EditGroup from "../pages/Group/EditGroup";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path={"/country"}
            element={
              <AccessControl
                children={<CountryList />}
                allowedPermissions={["can_view_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/country/edit/:id"}
            element={
              <AccessControl
                children={<EditCountry />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/country/create"}
            element={
              <AccessControl
                children={<CreateCountry />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/city"}
            element={
              <AccessControl
                children={<CityList />}
                allowedPermissions={["can_view_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/city/edit/:id"}
            element={
              <AccessControl
                children={<EditCity />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/create-city"}
            element={
              <AccessControl
                children={<CreateCity />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/group"}
            element={
              <AccessControl
                children={<GroupList />}
                allowedPermissions={["can_view_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/create-group"}
            element={
              <AccessControl
                children={<CreateGroup />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/group/edit/:id"}
            element={
              <AccessControl
                children={<EditGroup />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />

          <Route
            path={"/state"}
            element={
              <AccessControl
                children={<StateList />}
                allowedPermissions={["can_view_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/state/edit/:id"}
            element={
              <AccessControl
                children={<EditState />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/create-state"}
            element={
              <AccessControl
                children={<CreateState />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/district"}
            element={
              <AccessControl
                children={<DistrictList />}
                allowedPermissions={["can_view_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/district/edit/:id"}
            element={
              <AccessControl
                children={<EditDistrict />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/create-district"}
            element={
              <AccessControl
                children={<CreateDistrict />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
